// extracted by mini-css-extract-plugin
export default {"heroContent":"Hero_heroContent__Ohe34","heroImg":"Hero_heroImg__Bhee8","title":"Hero_title__da-vQ","subTitle":"Hero_subTitle__UMeCn","wrapTitle":"Hero_wrapTitle__shsSP"};